import Contract from '@Contract/views/Contract.vue';
import Project from '@Contract/views/Project.vue';
import permissions from '../Share/config/permissions';
export default [
  {
    path: '/:id/admin/contracts',
    name: 'contracts',
    component: Contract,
    meta: {
      requiresAuth: true,
      layout: 'admin-layout',
      facilityScope: true,
      permissions: [permissions.Contracts.View]
    },
  },
  {
    path: '/:id/admin/contracts/:contractId',
    name: 'projects',
    component: Project,
    meta: {
      requiresAuth: true,
      layout: 'admin-layout',
      facilityScope: true,
      permissions: [permissions.TaskBoardProjects.View]
    },
  },
];
